var rich_content_viewer_default = {
  "fontElementMap": "ol69f",
  "wrapper": "tw3v6",
  "pluginContainerMobile": "VVaum",
  "viewer": "Jh16y",
  "android": "Bk4Ei",
  "rootedTraversedContent": "Hy1uF",
  "atomic": "bFpOB",
  "toolbar": "AdGKG",
  "block": "JcqJq"
};
export {
  rich_content_viewer_default as default
};
//# sourceMappingURL=rich-content-viewer-scss.js.map
